import React from 'react';
// import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
// import { isMobile } from 'react-device-detect';
import { Divider } from '@material-ui/core';

import { isMobile } from 'react-device-detect';

const useStyles = makeStyles(theme => ({
  card: {
    maxWidth: 270,
    //minHeight: 200
  },
  cardMobile: {
    // maxWidth: 200,
    // width: '100%',
    // height: 110
  },
  /* logo: {
    [theme.breakpoints.up('xs')]: {
      width: '37%',
      height: '50%',
      paddingLeft: '10px',
      paddingTop: '2%'
    },
    [theme.breakpoints.up('sm')]: {
      width: `37%`,
      height: '40%',
    },
    [theme.breakpoints.up('md')]: {
      width: `50%`,
      height: '60%',

    },
    [theme.breakpoints.up('lg')]: {
      width: `50%`,
      height: '60%',

    },
    [theme.breakpoints.up('xl')]: {
      width: `50%`,
      height: '60%',

    },
  }, */
  logo: {
    minWidth: '190px',
    maxWidth: '20px',
    padding: "3%"
  }
}));

const MenuHeader = props => {

  const classes = useStyles();
  if (isMobile) {
    return (
      <Card elevation={0} className={classes.cardMobile} style={{ backgroundColor: '#2E2757', borderColor: 'white' }}>
        <CardActionArea style={{ width: '400px', borderColor: 'white' }}>
          <img src={process.env.PUBLIC_URL + '/images/logo_en_bn.svg'} alt="Logo" className={classes.logo}/>
        </CardActionArea>
        <Divider component="li" style={{ backgroundColor: '#2e2757' }} />
      </Card>
    );
  } else {
    return (
      <Card elevation={0} className={classes.card} style={{ backgroundColor: '#2E2757', borderColor: 'white' }}>
        <CardActionArea style={{ width: '500px', height: '100px', borderColor: 'white' }}>
          {/*                   <img src={process.env.PUBLIC_URL + '/images/Logo-544x96.png'} alt="Logo" className={classes.logo}  />
 */}            </CardActionArea>
        <Divider component="li" style={{ backgroundColor: '#2e2757' }} />
      </Card>
    );
  }

};

MenuHeader.propTypes = {

};

export default MenuHeader;
